import React from 'react';
import { Box, Text } from '@razorpay/blade/components';

export const DetailRow = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <Box display="flex" justifyContent="space-between" alignItems="center">
    <Text size="small" weight="medium" color="surface.text.gray.muted">
      {label}
    </Text>
    <Text size="small" weight="semibold" color="surface.text.gray.subtle" textAlign="right">
      {value}
    </Text>
  </Box>
);
